<ng-container *ngIf="item">
	<ion-item detail="false" button (click)="onClickToggleSection()">
		<ion-text>
			{{ item.categoryDesc }}<span *ngIf="item.equipName">:</span>
			<span *ngIf="item.equipName" class="equip-name">
				{{ item.equipName }}
			</span>
			<div style="margin-left:10px;" *ngIf="item.attributes[0] as primAttr">
				{{ primAttr.name }}: {{ primAttr.value || "" }}
			</div>

		</ion-text>
		<ion-icon
			[name]="isExpanded ? 'chevron-up-outline' : 'chevron-down-outline'"
			slot="end"
		></ion-icon>
	</ion-item>
	<ion-item lines="none" *ngIf="isExpanded" color="light">
		<ion-grid>
			<ion-row *ngFor="let attribute of item.attributes.slice(1)">
				<ion-col size="6" size-sm>
					<ion-label text-wrap
							   class="ion-text-wrap bold"
							   [innerHTML]="attribute.name + ':'"></ion-label>
				</ion-col>
				<ion-col size="6" size-sm>
					<ion-text [innerHTML]="attribute.value"></ion-text>
				</ion-col>
			</ion-row>
			<ion-row>
				<ion-col size="6" size-sm>
					<ion-label class="ion-text-wrap bold">
						Customer Service:
					</ion-label>
				</ion-col>
				<ion-col size="6" size-sm>
					<ion-text>{{ item.customerServiceDescription }}</ion-text>
				</ion-col>
			</ion-row>
			<ion-row>
				<ion-col size="6" size-sm>
					<ion-label class="ion-text-wrap bold">
						ID:
					</ion-label>
				</ion-col>
				<ion-col size="6" size-sm>
					<ion-text>{{ item.id }}</ion-text>
				</ion-col>
			</ion-row>
			<ion-row *ngIf="item.provisionNote">
				<ion-col size="6" size-sm>
					<ion-label class="ion-text-wrap bold">
						Provision Note:
					</ion-label>
				</ion-col>
				<ion-col size="6" size-sm>
					<ion-text>{{ item.provisionNote }}</ion-text>
				</ion-col>
			</ion-row>
			<ion-row *ngIf="!isReadOnly">
				<ion-col size="6" size-sm>
					<ng-container *ngIf="item.statusId === 5; else editable">
						<ion-button expand="block" (click)="onClickSetActive()">
							Set Active
						</ion-button>
					</ng-container>

					<ng-template #editable>
						<ion-button expand="block"
									(click)="onClickShowEditInventory()">
							Edit
						</ion-button>
					</ng-template>
				</ion-col>
				<ion-col size="6" size-sm>
					<ion-button expand="block"
								(click)="onClickShowRemoveInventory()"
								color="danger">
						Remove
					</ion-button>
				</ion-col>
			</ion-row>
		</ion-grid>
	</ion-item>
</ng-container>
